"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var get_1 = __importDefault(require("lodash/get"));
var nucleus_1 = require("@lifesize/nucleus");
var remoting_1 = require("../constants/remoting");
var redux_1 = require("../utils/redux");
exports.initialState = {
    activeCall: null,
    incomingCall: null
};
exports.default = redux_1.createReducer(exports.initialState, (_a = {},
    _a[remoting_1.actions.REMOTE_STATE_UPDATED] = function (state, action) {
        return __assign(__assign({}, state), action.payload.state);
    },
    _a[nucleus_1.nucleusConstants.LOGOUT_FINISHED] = function () { return exports.initialState; },
    _a[remoting_1.actions.DATA_CHANNEL_CLOSED] = function (state) {
        return get_1.default(state, 'app.remoting.pairing.isDisplay')
            ? state
            : __assign(__assign({}, state), { display: __assign(__assign({}, state.display), { sipIncomingCall: null, sipActiveCall: null }), activeCall: null, incomingCall: null });
    },
    _a));
